import { Component, Input } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SlideMenuService } from '../../services/slide-menu.service';
import { NeighborhoodService } from '../../services/neighborhood.service';
import { AdministratorModalComponent } from '../administrator-modal/administrator-modal.component';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss'
})
export class MainHeaderComponent {

  @Input() title: string = '';

  /** Fraccionamiento de la pantalla. El header del dashboard no lo manda y ese
      vacío es la puerta: sin colonia no hay campana ni preferencias, porque
      ambas cuelgan de `/neighborhoods/{id}`. */
  @Input() neighborhoodId?: string;

  constructor(
    public authService: AuthService,
    private modalService: NgbModal,
    public neighborhoodService: NeighborhoodService,
    public router: Router,
    public slideMenuService: SlideMenuService
  ) {

  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR openPreferences                           */
  /* -------------------------------------------------------------------------- */
  // region openPreferences
  /**
   * Preferencias es el MISMO modal que usa la pantalla de administradores, en
   * modo `preferences`: mismo aspecto, un solo switch. Se abre igual que en
   * `administrators-page` —`modalService.open` y datos por componentInstance—,
   * pero sin pasarle `administrator`: en este modo el modal pide su propio
   * registro, porque el GET de administradores es solo para sudo.
   */
  openPreferences() {

    const modalRef = this.modalService.open(
      AdministratorModalComponent
    );

    modalRef.componentInstance.mode = 'preferences';
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;

  }

}
